import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeJTransaction, UiPxSchedulingModule } from '@wlp/ui-px-scheduling';

let SchedulingService = class SchedulingService {
    constructor(transaction) {
        this.transaction = transaction;
    }
    updateRegister(uuid, body) {
        return this.transaction.updateRegister(uuid, body);
    }
    createRecurringTransaction(body) {
        return this.transaction.createRecurringTransaction(body);
    }
    createScheduling(body) {
        return this.transaction.createScheduling(body);
    }
    //obter todas as transações de uma serie de pagamentos recorrentes
    getRecurringScheduling(uuidRecurringSchedule, uuidAccountPayment) {
        return this.transaction.getRecurringScheduling(uuidRecurringSchedule, uuidAccountPayment);
    }
    getAllScheduling(uuidAccountPayment, startExecutionDate, endExecutionDate, limit, page) {
        return this.transaction.getAllScheduling(uuidAccountPayment, startExecutionDate, endExecutionDate, limit, page);
    }
    cancelScheduling(uuid) {
        return this.transaction.cancelScheduling(uuid);
    }
    cancelRecurringScheduling(uuid) {
        return this.transaction.cancelRecurringScheduling(uuid);
    }
    getReceiptSchedule(transactionId) {
        return this.transaction.getReceiptSchedule(transactionId);
    }
};
SchedulingService.ctorParameters = () => [
    { type: SpeJTransaction }
];
SchedulingService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SchedulingService_Factory() { return new SchedulingService(ɵɵinject(SpeJTransaction)); }, token: SchedulingService, providedIn: "root" });
SchedulingService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], SchedulingService);

let UiBSchedulingModule = class UiBSchedulingModule {
};
UiBSchedulingModule = __decorate([
    NgModule({
        declarations: [],
        providers: [
            SchedulingService,
        ],
        imports: [CommonModule, FormsModule, IonicModule, UiBsUtilModule, UiPxSchedulingModule]
    })
], UiBSchedulingModule);

/*
 * Public API Surface of ui-bs-notice
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SchedulingService, UiBSchedulingModule };
//# sourceMappingURL=wlp-ui-bs-scheduling.js.map
